import dayjs from 'dayjs';

export const InspectionDateTimeCell: React.FC<{ datetime: string | null }> = ({ datetime }) => {
  if (datetime) {
    return <>{dayjs(datetime).format('DD.MM.YYYY HH:mm')}</>;
  } else {
    return <h6 className="text-danger text-center">---</h6>;
  }
};
